import React, { useEffect,useState } from 'react'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare , faGear , faCirclePlus , faCircleArrowLeft} from '@fortawesome/free-solid-svg-icons';
import { ReactSession } from 'react-client-session';
import Networklist from '../../../config/Networklist.json';

import styled from 'styled-components';
import SelectedChain from '../../../hooks/useSelectedChain';
 
function SelectNetwork() {
 
    const changeNetwork = (n)=>{
        console.log(n)
        const currentNetwork = Networklist.find(network => network.networkname === n);
        ReactSession.set("network", currentNetwork);
         
        window.location="/";
    }
  
     return ( 
     <>
        <div className="choose-network flat-tabs">
                    <h6>Select Network</h6>
                   <span>Main Networks</span> 
                     
                    <ul className="menu-tab mt-2">
                    <li className={ReactSession.get("network").networkname == "BSC" ? "active" : null } onClick={()=>{changeNetwork("BSC")}}>
                        <img src="assets/images/common/wallet_1.png" alt="" />
                        <span>BSC</span>
                      </li>
                     <li className={ReactSession.get("network").networkname == "AVAX" ? "active" : null }  onClick={()=>{changeNetwork("AVAX")}}>
                        <img src="https://cryptologos.cc/logos/avalanche-avax-logo.png?v=029" alt="" />
                        <span>AVAX</span>
                      </li>
                    <li className={ReactSession.get("network").networkname == "ARBITRUM" ? "active" : null } onClick={()=>{changeNetwork("ARBITRUM")}}>
                        <img src="assets/images/arbitrum.png" alt="" />
                        <span>ARBITRUM</span>
                      </li>
                      <li className={ReactSession.get("network").networkname == "POLYGON" ? "active" : null }  onClick={()=>{changeNetwork("POLYGON")}}>
                        <img src="https://cryptologos.cc/logos/polygon-matic-logo.png?v=024" alt="" />
                        <span>Polygon</span>
                      </li>
                      <li className={ReactSession.get("network").networkname == "FANTOM" ? "active" : null } onClick={()=>{changeNetwork("FANTOM")}}>
                        <img src="https://cryptologos.cc/logos/fantom-ftm-logo.png?v=024" alt="" />
                        <span>Fantom</span>
                      </li>
                      
                    </ul>

                    <span>Testnet</span> 
                    <ul className="menu-tab mt-2">
                     
                      <li className={ReactSession.get("network").networkname === "BSCTESTNET" ? "active" : null } onClick={()=>{changeNetwork("BSCTESTNET")}}>
                        <img src="assets/images/common/wallet_1.png" alt="" />
                        <span>BSC Testnet</span>
                      </li>
                    </ul>
         </div>
     </> 
  ); 

} 

export default SelectNetwork;
